<template>
  <div class="row justify-center">
    <div class="col-md-6">
      <div class="cardCustom">
        <div class="card cardCustom__side">
          <div class="cardCustom__header">
            <div class="cardCustom__header-text">
              <span class="uppercase"> Authentication </span>
            </div>
            <div class="cardCustom__header-info__item">
              <button
                v-tooltip="{
                  content: 'Please enter credentials of your energy supplier',
                  placement: 'bottom-center',
                  classes: ['info'],
                }"
              >
                <i class="fas fa-info-circle" />
              </button>
            </div>
          </div>
          <div class="content pt-20">
            <h5>Please enter your Energy Supplier's credentials to import your usage data in Vivid Leaf</h5>
            <p>Important! Import can take up to 10 minutes.</p>
            <div class="row">
              <div class="col-md-12">
                <fg-input type="text" label="Username" placeholder="example@gmail.com" v-model="form.username">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <fg-input type="password" label="Password" placeholder="Password" v-model="form.password"> </fg-input>
              </div>
            </div>
            <div class="text-center">
              <p-button type="success" :loading="submitLoading" @click.native.prevent="submit"> submit </p-button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsageGreenButtonController from '@/controllers/Consumption/GreenButton/UsageGreenButtonController';
import AssignEnergySupplierToCompany from '@/controllers/Consumption/AssignEnergySupplierToCompany';

export default {
  name: 'EnergySupplierAuthenticationPage',
  data() {
    return {
      form: {
        energy_supplier_id: null,
      },
      submitLoading: false,
    };
  },
  methods: {
    async submit() {
      this.submitLoading = true;
      let company_id = this.$store.getters.company.company_id;
      this.form.energy_supplier_id = this.$route.params.id;
      if (this.form.username && this.form.password) {
        try {
          await AssignEnergySupplierToCompany.update(this.form.energy_supplier_id, {
            company_id: company_id,
            status: 'not connected',
          });
          await UsageGreenButtonController.index(this.$store.getters.company.company_id, this.form);
          this.$notify({
            type: 'success',
            title: 'Congrats! Authentication was successful. Your data will be imported soon.',
          });
          await this.$router.push('/consumption');
        } catch (e) {
          this.$notify({
            type: 'error',
            title: 'Sorry, authentication failed. Please contact support team',
          });
        }
      } else {
        this.$notify({
          type: 'error',
          title: 'Please enter username and password',
        });
      }

      this.submitLoading = false;
    },
  },
};
</script>

<style scoped></style>
